<template>
    <div id="ContainerClinicalChartReview">
        <ChartReviewBase v-bind:Origin="'Clinical'" />
    </div>
</template>
<script>
import ChartReviewBase from "@/components/pages/chartreview/ChartReview";
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission'

export default {
    /*beforeRouteEnter(to, from, next) {
        next(async vm => {
            const iUA = await vm.$store.state.isUseChartReview;
            if(iUA) next()
            else next('/accessdenied');
        }) 
  },*/
  /*beforeRouteEnter(to, from, next) {
        next(async vm => {
            const iPI = await vm.CanViewAllowed();
            if(iPI) next()
            else next('/accessdenied');
        }) 
  },*/
  name: 'ClinicalChartReview',
   mixins: [ChartReviewBase,DBFunctions,Permission],

   data(){
       return{
        //permission:[],
        //Menu : this.$store.state.leftMenu,
       }
   },

    methods:{
    /*CanViewAllowed(){
        return this.permission[0].roleCanView;
    },*/   
    },

    created(){
        //this.getPermissionLeftMenu(this.Menu,this.$route.path,this.permission);
        this.InitializePermissions('ListView', this.$store.state.isUseChartReview);
        if (!this.IsAccessAllowed()) {
            return;
        }

    EventBus.$on("ShowWeel", function (isShow) { 
        isShow ? this.$emit('load', true) : this.$emit('load', false);     
     }.bind(this));
    },

   mounted(){
        if (!this.IsAccessAllowed()) {
            return;
        }
   },

   destroyed(){
     
   }
};
</script>